import { EventEditView, EventListView, EventNewView, EventShowView } from '@/views/authenticated/admin/events';
import {
  EventMetadataView,
  EventOverviewView, EventPhotosView,
  EventPricesView,
  EventReportView,
} from '@/views/authenticated/admin/events/show/tabs';

export default [
  {
    path: '/admin/events',
    name: 'app_admin_event_list',
    component: EventListView,
    meta: { title: 'Events', requiresAdmin: true },
  },
  {
    path: '/admin/events/new',
    name: 'app_admin_event_new',
    component: EventNewView,
    meta: { title: 'Add Event', requiresAdmin: true },
  },
  {
    path: '/admin/events/:slug/edit',
    name: 'app_admin_event_edit',
    component: EventEditView,
    meta: { title: 'Edit Event', requiresAdmin: true },
  },
  {
    path: '/admin/events/:slug',
    component: EventShowView,
    name: 'app_admin_event_show',
    meta: { requiresAdmin: true },
    children: [
      {
        path: 'overview',
        name: 'app_admin_event_show_overview',
        component: EventOverviewView,
        meta: { title: 'Event Overview' },
      },
      {
        path: 'prices',
        name: 'app_admin_event_show_prices',
        component: EventPricesView,
        meta: { title: 'Event Prices' },
      },
      {
        path: 'metadata',
        name: 'app_admin_event_show_metadata',
        component: EventMetadataView,
        meta: { title: 'Event Metadata' },
      },
      {
        path: 'photos',
        name: 'app_admin_event_show_photos',
        component: EventPhotosView,
        meta: { title: 'Event Photos' },
      },
      {
        path: 'report',
        name: 'app_admin_event_show_report',
        component: EventReportView,
        meta: { title: 'Event Report' },
      },
    ],
  },
];
